import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Breadcrumbs,
  Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';
import MCPDashboard from '../components/MCP/MCPDashboard';

function MCPDashboardPage() {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 3 }}>
        <MuiLink component={Link} to="/dashboard" underline="hover" color="inherit">
          Dashboard
        </MuiLink>
        <Typography color="text.primary">MCP Management</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          MCP Management Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Manage your Model Context Protocol server, register flows as tools,
          and connect with MCP-compatible clients like Claude Desktop and VS Code.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              borderRadius: 2,
              flex: 1,
              minWidth: 200,
            }}
          >
            <Typography variant="h6" gutterBottom>
              🚀 Quick Start
            </Typography>
            <Typography variant="body2">
              Start your MCP server and register your flows as tools to use them
              in external applications.
            </Typography>
          </Paper>

          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: 'secondary.main',
              color: 'secondary.contrastText',
              borderRadius: 2,
              flex: 1,
              minWidth: 200,
            }}
          >
            <Typography variant="h6" gutterBottom>
              🔗 Client Integration
            </Typography>
            <Typography variant="body2">
              Connect Claude Desktop, VS Code, and other MCP-compatible
              applications to your flows.
            </Typography>
          </Paper>

          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: 'success.main',
              color: 'success.contrastText',
              borderRadius: 2,
              flex: 1,
              minWidth: 200,
            }}
          >
            <Typography variant="h6" gutterBottom>
              📊 Flow Discovery
            </Typography>
            <Typography variant="body2">
              Search, discover, and execute flows across your organization
              using semantic search.
            </Typography>
          </Paper>
        </Box>
      </Box>

      {/* Main Dashboard */}
      <Paper elevation={1} sx={{ borderRadius: 2 }}>
        <MCPDashboard />
      </Paper>

      {/* Footer Information */}
      <Box sx={{
        mt: 4, p: 3, bgcolor: 'grey.50', borderRadius: 2,
      }}
      >
        <Typography variant="h6" gutterBottom>
          📚 Resources & Documentation
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 2 }}>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Getting Started
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Learn how to set up MCP clients and register your first flows as tools.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              API Reference
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Complete API documentation for MCP server endpoints and client integration.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Flow Templates
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Pre-built templates for common use cases to accelerate development.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Troubleshooting
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Common issues and solutions for MCP integration and flow execution.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default MCPDashboardPage;
